export default __webpack_public_path__ + "static/media/377139af.svg";